import { useState } from 'react'
import { IoIosImages } from 'react-icons/io'
import { IoMdClose } from 'react-icons/io'

const Gallery = ({galleries}) => {

      const [modal, setModal] = useState(false)
      const [imgTemp, setImgTemp] = useState('')

      if(galleries.data) return
      
      const getImage = (src) => {
            setModal(true)
            setImgTemp(src)
      }

      const closeModal = () => {
            setModal(false)
      }

      return (
            <div className="gallery_content">
                  <div className={modal? "modal_content open" : "modal_content"}>
                        <div className="modal_content__img">
                              <img src={imgTemp} alt="Large" />
                        </div>
                        <div className="modal_close" onClick={() => closeModal()}>
                              <IoMdClose />
                        </div>
                  </div>
                  <div className="box_wrapper">
                        <div className="header_box__content">
                              <div className="header_content_icon">
                                    <IoIosImages />
                              </div>
                              <h3>Gallery</h3>
                        </div>
                  </div>
                  <div className="box_content main">
                        <div className="gallery_wrapper">
                              {
                                    galleries.map((item) => (
                                          <div className="gallery_box" onClick={() => getImage(item.image)} key={item.description}>
                                                <img src={item.image} alt={item.description} />
                                          </div>
                                    ))
                              }
                        </div>
                        <div className="gallery_description">
                              <p>
                              Take nothing but pictures. Leave nothing but footprints. Take nothing but longing.
                              </p>
                        </div>
                  </div>
            </div>
      )
}

export default Gallery